<template>
 <v-bottom-sheet v-model="vkb_state">
  <v-sheet class="pt-3">
    <Keyboard v-if="$store.getters.kbd_active_input" :input="$store.getters.kbd_active_input" :layout="$store.getters.kbd_active_layout" @layout="e => $store.commit('setKbdLayout', e)" @exit="$store.dispatch('hideKeyboard')" :options="kbd_options"/>
  </v-sheet>
 </v-bottom-sheet>
</template>

<script>
import Keyboard from './Keyboard.vue'
import  { mapGetters } from 'vuex'

export default {
  methods: {
    outsideClick(){
      this.$store.dispatch('hideKeyboard')
    }
  },
  computed: {
    vkb_state: {
      get(){
        return this.$store.getters.kbd_active
      },
      set(val) {
        if (val === false) {
          this.$store.dispatch('hideKeyboard')
        }
      }
    },
    ...mapGetters(['kbd_options'])
  },
  components: {
    Keyboard,
  }
}
</script>